import { ApolloError } from '@apollo/client/core'

export interface DetectorError {
  code: string | null
  retryable: boolean
  retryAfterSeconds: number | null
  message: string
}

export const GENERIC_MESSAGE = 'Something went wrong. Please try again.'

export function readDetectorError(error: unknown): DetectorError {
  if (error instanceof ApolloError && error.graphQLErrors.length) {
    const first = error.graphQLErrors[0]
    const extensions = first.extensions ?? {}
    const retryAfter = Number(extensions.retryAfterSeconds)
    return {
      code: typeof extensions.code === 'string' ? extensions.code : null,
      retryable: extensions.retryable === true,
      retryAfterSeconds: Number.isFinite(retryAfter) ? retryAfter : null,
      message: first.message || GENERIC_MESSAGE,
    }
  }
  return {
    code: null,
    retryable: true,
    retryAfterSeconds: null,
    message:
      error instanceof Error && error.message ? error.message : GENERIC_MESSAGE,
  }
}

export const isCapacityError = (error: DetectorError) =>
  error.code === 'DETECTOR_BUSY' ||
  error.code === 'DETECTOR_DRAINING' ||
  error.code === 'REGISTRY_BUSY' ||
  error.code === 'RATE_LIMITED'

export const sleep = (ms: number) =>
  new Promise<void>((resolve) => setTimeout(resolve, ms))
